import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ManualShiftChanges } from "../../types/ganttChart";

type EditEmployeeWorkTime = {
  shiftId: number;
  workTimeStart: string;
  workTimeEnd: string;
};

type EmployeeSettingSlice = {
  manualEdits: {
    [shiftId: number]: ManualShiftChanges
  }
}

const initialState: EmployeeSettingSlice = {
  manualEdits: {}
}

const employeeSettingsSlice = createSlice({
  name: "employee-settings",
  initialState,
  reducers: {
    editEmployeeWorkTime(state, action: PayloadAction<EditEmployeeWorkTime>) {
      const { shiftId, workTimeStart, workTimeEnd } = action.payload;
      const previousEdits = state.manualEdits[shiftId] ?? {}

      state.manualEdits[shiftId] = {
        ...previousEdits,
        employeeWorkTime: {
          workTimeStart,
          workTimeEnd
        }
      }
    },
    clearEmployeeWorkTimeEdit(state, action: PayloadAction<{ shiftId: number }>) {
      delete state.manualEdits[action.payload.shiftId]
    },
    clearManualEdits(state) {
      state.manualEdits = {}
    }
  }
})

export const { editEmployeeWorkTime, clearManualEdits, clearEmployeeWorkTimeEdit } = employeeSettingsSlice.actions
export default employeeSettingsSlice.reducer
